import "./Contact.module.css";
import TopNavigation from "@/reusable_sections/Header";
import ContactUs from "./sections/ContactUs";
import ContactMessageForm from "./sections/ContactMessageForm";
import InformationAndRights from "@/reusable_sections/Footer";
export default function ContactPage() {
  return <div>
      <TopNavigation />
      <ContactUs />
      <ContactMessageForm />
      <InformationAndRights />
    </div>;
}